import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HERO_SLIDES = [
  "images/careers/1.jpg",
  "images/careers/2.jpg",
  "images/careers/3.jpg",
  "images/careers/4.jpg",
  "images/careers/5.jpg",
];

const sliderSettings = {
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 1000,
  fade: true,
  cssEase: "ease-in-out",
  slidesToShow: 1,
  slidesToScroll: 1,
  pauseOnHover: false,
};

const Section1 = ({ url }) => {
  return (
    <section className="careers-section-1">
      <div className="careers-hero">
        <Slider {...sliderSettings} className="careers-hero-slider">
          {HERO_SLIDES.map((slide) => (
            <div className="careers-hero-slide" key={slide}>
              <img src={url + slide} alt="ExD Digital team" />
            </div>
          ))}
        </Slider>

        <div className="careers-hero-content">
          <h1 data-aos="fade-up" data-aos-duration="1100">
            Build The Future <span className="yellow-txt">With Us</span>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default Section1;
